<app-mobile-header-menu menulink="/menu/documentos"></app-mobile-header-menu>
<aside class="sidebar">
  <header class="sidebar__header">
    <a routerLink="/" class="sidebar__header-brand">
      @if (whitelabelService.whitelabel?.pdf_logo_mini) {
        <img [src]="whitelabelService.whitelabel?.pdf_logo_mini" />
      }
    </a>

    <a class="btn-M btn-text icon-start" (click)="goBack()">
      <i class="fal fa-chevron-left"></i>
      {{ 'button.back' | translate }}
    </a>
  </header>

  <main class="sidebar__wrapper">
    <app-fill-dynamic-document-form
      [dateFormat]="currentUser?.locale?.date_format"
      [fieldsToFill]="fieldsToFill"
      [context]="InlineFieldContext.FillCreator"
      (submitFields)="submitFilledFields($event)"
    ></app-fill-dynamic-document-form>

    @if (!isRendered) {
      <div class="form__container">
        <div class="rendering rendering__form-field"></div>
        <div class="rendering rendering__form-field"></div>
        <div class="rendering rendering__form-field"></div>
        <div class="rendering rendering__form-field"></div>
      </div>
    }
  </main>
</aside>

<section class="template" [class.d-none]="!isRendered">
  <div class="template__head">
    <div class="template__head-container">
      <h1 class="template__head-title">{{ dynamicTemplate?.name }}</h1>
      <p class="template__head-descr">
        {{
          ('documents.createdOn' | translate: { date: dynamicTemplate?.created_at | dateTime: 'mediumDate' }) +
            (dynamicTemplate?.created_at !== dynamicTemplate?.updated_at ? ', ' + ('documents.updatedOn' | translate: { date: dynamicTemplate?.updated_at | dateTime: 'mediumDate' } | lowercase) : '')
        }}
      </p>
      @if (currentUser?.currentPermissions.actions_templates_gr) {
        <div ngbDropdown display="dynamic" placement="bottom-right" class="template__dropdown">
          <button id="template__head-dropdown" class="btn-M btn-text icon-only" ngbDropdownToggle>
            <i class="far fa-ellipsis-v"></i>
          </button>
          <div aria-labelledby="template__head-dropdown" ngbDropdownMenu>
            <button ngbDropdownItem (click)="editTemplate()">
              <i class="fa-regular fa-edit"></i>
              {{ 'button.edit' | translate }}
            </button>
            <button ngbDropdownItem (click)="deleteTemplate()">
              <i class="fa-regular fa-trash"></i>
              {{ 'button.exclude' | translate }}
            </button>
          </div>
        </div>
      }
    </div>
  </div>

  <app-dynamic-document-viewer
    #renderedTemplate
    [content]="dynamicTemplate?.content"
    [theme]="dynamicTemplate?.theme"
    [scale]="renderedDocumentScale"
    [context]="InlineFieldContext.FillCreator"
    (recalculateScale)="updateRenderedDocumentScale()"
  ></app-dynamic-document-viewer>
</section>

@if (!isRendered) {
  <section class="template">
    <div class="template__head">
      <div class="template__head-container">
        <h1 class="template__head-title rendering">&nbsp;</h1>
        <p class="template__head-descr rendering">&nbsp;</p>
      </div>
    </div>
    <div class="template__wrapper rendering">
      <div class="template__wrapper-paper"></div>
    </div>
  </section>
}
